import React from "react";
import ReactDom from "react-dom";

import "./styling/SideDrawer.css";

const SideDrawer = (props) => {
  const content = (
    <aside className={`side-drawer ${props.show ? 'show' : ''}`} onClick={props.onClick}>
      {props.children}
    </aside>
  );

  return ReactDom.createPortal(content, document.getElementById("drawer-hook"));
};

export default React.memo(SideDrawer);
